
import React from "react";
export default function Social() {
  return (
    <div className="Social-btn">
      <button className="btn1">
        <a href="mailto:arunshukla98710@gmail.com" target="_blank">
          <i className="fas fa-envelope">&nbsp;&nbsp;Emal</i>
        </a>
      </button>
      <button className="btn2">
        <a
          href="https://www.linkedin.com/in/arun-shukla-1399a9196/"
          target="_blank"
        >
          <i className="fab fa-linkedin-in">&nbsp;&nbsp;LinkedIn</i>
        </a>
      </button>
    </div>
  );
}
